import { booleanAttribute, Component, Input } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";

@Component({
  selector: "app-progress-loading",
  templateUrl: "./progress-loading.component.html",
  styleUrl: "./progress-loading.component.scss",
  imports: [MatProgressBarModule],
})
export class ProgressLoadingComponent {
  @Input({ transform: booleanAttribute }) isLoading = true;
  @Input() loadingClass = "min-h-60";
}
